import { BigWinThresholds } from "ags/utils/win-magnitude";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { Timer } from "appworks/utils/timer";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";
import { DelayState } from "slotworks/state-machine/standard/states/delay-state";

export class ThemeDelayFreespinsExitState extends DelayState {
    protected bigWinDelayMs: number;
    protected normalDelayMs: number;

    constructor(normalDelayMs: number, bigWinDelayMs: number, skippable = false) {
        super(normalDelayMs, skippable);

        this.bigWinDelayMs = bigWinDelayMs;
        this.normalDelayMs = normalDelayMs;
    }

    public override onEnter() {
        const lastFreespinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
        Services.get(SlotBetService).getTotalStake();
        const winRatio = lastFreespinRecord.wonAmount / Services.get(SlotBetService).getTotalStake();
        // Check if last freespin was above the big win, otherwise delay with the normal delay:
        if(winRatio >= BigWinThresholds.BIG) {
            this.wait = this.bigWinDelayMs;
        } else {
            this.wait = this.normalDelayMs;
        }

        if (this.wait > 0) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), this.wait);
        } else {
            this.complete();
        }
    }
}
